/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyAccountImport } from './routes/verify-account'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as ExperiencesRouteImport } from './routes/experiences/route'
import { Route as AppRouteImport } from './routes/app/route'
import { Route as AdminRouteImport } from './routes/admin/route'
import { Route as IndexImport } from './routes/index'
import { Route as AdminIndexImport } from './routes/admin/index'
import { Route as ExperiencesSignupImport } from './routes/experiences/signup'
import { Route as ExperiencesRegisterImport } from './routes/experiences/register'
import { Route as ExperiencesLoginImport } from './routes/experiences/login'
import { Route as ExperiencesForgotPasswordImport } from './routes/experiences/forgot-password'
import { Route as ExperiencesClaimPartnerImport } from './routes/experiences/claim-partner'
import { Route as ExperiencesAcceptInvitationImport } from './routes/experiences/accept-invitation'
import { Route as AppBillingRouteImport } from './routes/app/billing/route'
import { Route as FeedbackTokenIndexImport } from './routes/feedback/$token/index'
import { Route as AppTimesheetsIndexImport } from './routes/app/timesheets/index'
import { Route as AppTimesheetIndexImport } from './routes/app/timesheet/index'
import { Route as AppTasksIndexImport } from './routes/app/tasks/index'
import { Route as AppSettingsIndexImport } from './routes/app/settings/index'
import { Route as AppResourcesIndexImport } from './routes/app/resources/index'
import { Route as AppReportsIndexImport } from './routes/app/reports/index'
import { Route as AppProjectsIndexImport } from './routes/app/projects/index'
import { Route as AppPlanningIndexImport } from './routes/app/planning/index'
import { Route as AppPartnersIndexImport } from './routes/app/partners/index'
import { Route as AppDashboardIndexImport } from './routes/app/dashboard/index'
import { Route as AppActivitiesIndexImport } from './routes/app/activities/index'
import { Route as PrintPlanPdfsRenderTokenImport } from './routes/print/plan-pdfs/$renderToken'
import { Route as AppPlanningResourcesImport } from './routes/app/planning/resources'
import { Route as AppPartnersLinkImport } from './routes/app/partners/link'
import { Route as AppDashboardSamarbejdeImport } from './routes/app/dashboard/samarbejde'
import { Route as AppDashboardPortfolioImport } from './routes/app/dashboard/portfolio'
import { Route as AppDashboardPmImport } from './routes/app/dashboard/pm'
import { Route as AppDashboardEmployeeImport } from './routes/app/dashboard/employee'
import { Route as SharedProjectsSharedProjectIdIndexImport } from './routes/shared/projects/$sharedProjectId/index'
import { Route as ExperiencesCreateNewCompanyStepIndexImport } from './routes/experiences/create-new-company/$step/index'
import { Route as AppTasksTaskIdIndexImport } from './routes/app/tasks/$taskId/index'
import { Route as AppResourcesResourceIdIndexImport } from './routes/app/resources/$resourceId/index'
import { Route as AppReportsTrackersIndexImport } from './routes/app/reports/trackers/index'
import { Route as AppReportsFeedbackIndexImport } from './routes/app/reports/feedback/index'
import { Route as AppProjectsProjectIdIndexImport } from './routes/app/projects/$projectId/index'
import { Route as AppPartnerProjectsProjectIdIndexImport } from './routes/app/partner-projects/$projectId/index'
import { Route as SharedProjectsSharedProjectIdClaimIndexImport } from './routes/shared/projects/$sharedProjectId/claim/index'
import { Route as SharedProjectsSharedProjectIdClaimFormImport } from './routes/shared/projects/$sharedProjectId/claim/form'

// Create/Update Routes

const VerifyAccountRoute = VerifyAccountImport.update({
  id: '/verify-account',
  path: '/verify-account',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const ExperiencesRouteRoute = ExperiencesRouteImport.update({
  id: '/experiences',
  path: '/experiences',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const AdminRouteRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AdminIndexRoute = AdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)

const ExperiencesSignupRoute = ExperiencesSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => ExperiencesRouteRoute,
} as any)

const ExperiencesRegisterRoute = ExperiencesRegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => ExperiencesRouteRoute,
} as any)

const ExperiencesLoginRoute = ExperiencesLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => ExperiencesRouteRoute,
} as any)

const ExperiencesForgotPasswordRoute = ExperiencesForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => ExperiencesRouteRoute,
} as any)

const ExperiencesClaimPartnerRoute = ExperiencesClaimPartnerImport.update({
  id: '/claim-partner',
  path: '/claim-partner',
  getParentRoute: () => ExperiencesRouteRoute,
} as any)

const ExperiencesAcceptInvitationRoute =
  ExperiencesAcceptInvitationImport.update({
    id: '/accept-invitation',
    path: '/accept-invitation',
    getParentRoute: () => ExperiencesRouteRoute,
  } as any)

const AppBillingRouteRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRouteRoute,
} as any)

const FeedbackTokenIndexRoute = FeedbackTokenIndexImport.update({
  id: '/feedback/$token/',
  path: '/feedback/$token/',
  getParentRoute: () => rootRoute,
} as any)

const AppTimesheetsIndexRoute = AppTimesheetsIndexImport.update({
  id: '/timesheets/',
  path: '/timesheets/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppTimesheetIndexRoute = AppTimesheetIndexImport.update({
  id: '/timesheet/',
  path: '/timesheet/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppTasksIndexRoute = AppTasksIndexImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSettingsIndexRoute = AppSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppResourcesIndexRoute = AppResourcesIndexImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppReportsIndexRoute = AppReportsIndexImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProjectsIndexRoute = AppProjectsIndexImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPlanningIndexRoute = AppPlanningIndexImport.update({
  id: '/planning/',
  path: '/planning/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPartnersIndexRoute = AppPartnersIndexImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardIndexRoute = AppDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppActivitiesIndexRoute = AppActivitiesIndexImport.update({
  id: '/activities/',
  path: '/activities/',
  getParentRoute: () => AppRouteRoute,
} as any)

const PrintPlanPdfsRenderTokenRoute = PrintPlanPdfsRenderTokenImport.update({
  id: '/print/plan-pdfs/$renderToken',
  path: '/print/plan-pdfs/$renderToken',
  getParentRoute: () => rootRoute,
} as any)

const AppPlanningResourcesRoute = AppPlanningResourcesImport.update({
  id: '/planning/resources',
  path: '/planning/resources',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPartnersLinkRoute = AppPartnersLinkImport.update({
  id: '/partners/link',
  path: '/partners/link',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardSamarbejdeRoute = AppDashboardSamarbejdeImport.update({
  id: '/dashboard/samarbejde',
  path: '/dashboard/samarbejde',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardPortfolioRoute = AppDashboardPortfolioImport.update({
  id: '/dashboard/portfolio',
  path: '/dashboard/portfolio',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardPmRoute = AppDashboardPmImport.update({
  id: '/dashboard/pm',
  path: '/dashboard/pm',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppDashboardEmployeeRoute = AppDashboardEmployeeImport.update({
  id: '/dashboard/employee',
  path: '/dashboard/employee',
  getParentRoute: () => AppRouteRoute,
} as any)

const SharedProjectsSharedProjectIdIndexRoute =
  SharedProjectsSharedProjectIdIndexImport.update({
    id: '/shared/projects/$sharedProjectId/',
    path: '/shared/projects/$sharedProjectId/',
    getParentRoute: () => rootRoute,
  } as any)

const ExperiencesCreateNewCompanyStepIndexRoute =
  ExperiencesCreateNewCompanyStepIndexImport.update({
    id: '/create-new-company/$step/',
    path: '/create-new-company/$step/',
    getParentRoute: () => ExperiencesRouteRoute,
  } as any)

const AppTasksTaskIdIndexRoute = AppTasksTaskIdIndexImport.update({
  id: '/tasks/$taskId/',
  path: '/tasks/$taskId/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppResourcesResourceIdIndexRoute =
  AppResourcesResourceIdIndexImport.update({
    id: '/resources/$resourceId/',
    path: '/resources/$resourceId/',
    getParentRoute: () => AppRouteRoute,
  } as any)

const AppReportsTrackersIndexRoute = AppReportsTrackersIndexImport.update({
  id: '/reports/trackers/',
  path: '/reports/trackers/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppReportsFeedbackIndexRoute = AppReportsFeedbackIndexImport.update({
  id: '/reports/feedback/',
  path: '/reports/feedback/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppProjectsProjectIdIndexRoute = AppProjectsProjectIdIndexImport.update({
  id: '/projects/$projectId/',
  path: '/projects/$projectId/',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppPartnerProjectsProjectIdIndexRoute =
  AppPartnerProjectsProjectIdIndexImport.update({
    id: '/partner-projects/$projectId/',
    path: '/partner-projects/$projectId/',
    getParentRoute: () => AppRouteRoute,
  } as any)

const SharedProjectsSharedProjectIdClaimIndexRoute =
  SharedProjectsSharedProjectIdClaimIndexImport.update({
    id: '/shared/projects/$sharedProjectId/claim/',
    path: '/shared/projects/$sharedProjectId/claim/',
    getParentRoute: () => rootRoute,
  } as any)

const SharedProjectsSharedProjectIdClaimFormRoute =
  SharedProjectsSharedProjectIdClaimFormImport.update({
    id: '/shared/projects/$sharedProjectId/claim/form',
    path: '/shared/projects/$sharedProjectId/claim/form',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/experiences': {
      id: '/experiences'
      path: '/experiences'
      fullPath: '/experiences'
      preLoaderRoute: typeof ExperiencesRouteImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/verify-account': {
      id: '/verify-account'
      path: '/verify-account'
      fullPath: '/verify-account'
      preLoaderRoute: typeof VerifyAccountImport
      parentRoute: typeof rootRoute
    }
    '/app/billing': {
      id: '/app/billing'
      path: '/billing'
      fullPath: '/app/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/experiences/accept-invitation': {
      id: '/experiences/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/experiences/accept-invitation'
      preLoaderRoute: typeof ExperiencesAcceptInvitationImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/experiences/claim-partner': {
      id: '/experiences/claim-partner'
      path: '/claim-partner'
      fullPath: '/experiences/claim-partner'
      preLoaderRoute: typeof ExperiencesClaimPartnerImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/experiences/forgot-password': {
      id: '/experiences/forgot-password'
      path: '/forgot-password'
      fullPath: '/experiences/forgot-password'
      preLoaderRoute: typeof ExperiencesForgotPasswordImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/experiences/login': {
      id: '/experiences/login'
      path: '/login'
      fullPath: '/experiences/login'
      preLoaderRoute: typeof ExperiencesLoginImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/experiences/register': {
      id: '/experiences/register'
      path: '/register'
      fullPath: '/experiences/register'
      preLoaderRoute: typeof ExperiencesRegisterImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/experiences/signup': {
      id: '/experiences/signup'
      path: '/signup'
      fullPath: '/experiences/signup'
      preLoaderRoute: typeof ExperiencesSignupImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexImport
      parentRoute: typeof AdminRouteImport
    }
    '/app/dashboard/employee': {
      id: '/app/dashboard/employee'
      path: '/dashboard/employee'
      fullPath: '/app/dashboard/employee'
      preLoaderRoute: typeof AppDashboardEmployeeImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/pm': {
      id: '/app/dashboard/pm'
      path: '/dashboard/pm'
      fullPath: '/app/dashboard/pm'
      preLoaderRoute: typeof AppDashboardPmImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/portfolio': {
      id: '/app/dashboard/portfolio'
      path: '/dashboard/portfolio'
      fullPath: '/app/dashboard/portfolio'
      preLoaderRoute: typeof AppDashboardPortfolioImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/samarbejde': {
      id: '/app/dashboard/samarbejde'
      path: '/dashboard/samarbejde'
      fullPath: '/app/dashboard/samarbejde'
      preLoaderRoute: typeof AppDashboardSamarbejdeImport
      parentRoute: typeof AppRouteImport
    }
    '/app/partners/link': {
      id: '/app/partners/link'
      path: '/partners/link'
      fullPath: '/app/partners/link'
      preLoaderRoute: typeof AppPartnersLinkImport
      parentRoute: typeof AppRouteImport
    }
    '/app/planning/resources': {
      id: '/app/planning/resources'
      path: '/planning/resources'
      fullPath: '/app/planning/resources'
      preLoaderRoute: typeof AppPlanningResourcesImport
      parentRoute: typeof AppRouteImport
    }
    '/print/plan-pdfs/$renderToken': {
      id: '/print/plan-pdfs/$renderToken'
      path: '/print/plan-pdfs/$renderToken'
      fullPath: '/print/plan-pdfs/$renderToken'
      preLoaderRoute: typeof PrintPlanPdfsRenderTokenImport
      parentRoute: typeof rootRoute
    }
    '/app/activities/': {
      id: '/app/activities/'
      path: '/activities'
      fullPath: '/app/activities'
      preLoaderRoute: typeof AppActivitiesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/dashboard/': {
      id: '/app/dashboard/'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/partners/': {
      id: '/app/partners/'
      path: '/partners'
      fullPath: '/app/partners'
      preLoaderRoute: typeof AppPartnersIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/planning/': {
      id: '/app/planning/'
      path: '/planning'
      fullPath: '/app/planning'
      preLoaderRoute: typeof AppPlanningIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/projects/': {
      id: '/app/projects/'
      path: '/projects'
      fullPath: '/app/projects'
      preLoaderRoute: typeof AppProjectsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/reports/': {
      id: '/app/reports/'
      path: '/reports'
      fullPath: '/app/reports'
      preLoaderRoute: typeof AppReportsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/resources/': {
      id: '/app/resources/'
      path: '/resources'
      fullPath: '/app/resources'
      preLoaderRoute: typeof AppResourcesIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tasks/': {
      id: '/app/tasks/'
      path: '/tasks'
      fullPath: '/app/tasks'
      preLoaderRoute: typeof AppTasksIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/timesheet/': {
      id: '/app/timesheet/'
      path: '/timesheet'
      fullPath: '/app/timesheet'
      preLoaderRoute: typeof AppTimesheetIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/timesheets/': {
      id: '/app/timesheets/'
      path: '/timesheets'
      fullPath: '/app/timesheets'
      preLoaderRoute: typeof AppTimesheetsIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/feedback/$token/': {
      id: '/feedback/$token/'
      path: '/feedback/$token'
      fullPath: '/feedback/$token'
      preLoaderRoute: typeof FeedbackTokenIndexImport
      parentRoute: typeof rootRoute
    }
    '/app/partner-projects/$projectId/': {
      id: '/app/partner-projects/$projectId/'
      path: '/partner-projects/$projectId'
      fullPath: '/app/partner-projects/$projectId'
      preLoaderRoute: typeof AppPartnerProjectsProjectIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/projects/$projectId/': {
      id: '/app/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/app/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/reports/feedback/': {
      id: '/app/reports/feedback/'
      path: '/reports/feedback'
      fullPath: '/app/reports/feedback'
      preLoaderRoute: typeof AppReportsFeedbackIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/reports/trackers/': {
      id: '/app/reports/trackers/'
      path: '/reports/trackers'
      fullPath: '/app/reports/trackers'
      preLoaderRoute: typeof AppReportsTrackersIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/resources/$resourceId/': {
      id: '/app/resources/$resourceId/'
      path: '/resources/$resourceId'
      fullPath: '/app/resources/$resourceId'
      preLoaderRoute: typeof AppResourcesResourceIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/app/tasks/$taskId/': {
      id: '/app/tasks/$taskId/'
      path: '/tasks/$taskId'
      fullPath: '/app/tasks/$taskId'
      preLoaderRoute: typeof AppTasksTaskIdIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/experiences/create-new-company/$step/': {
      id: '/experiences/create-new-company/$step/'
      path: '/create-new-company/$step'
      fullPath: '/experiences/create-new-company/$step'
      preLoaderRoute: typeof ExperiencesCreateNewCompanyStepIndexImport
      parentRoute: typeof ExperiencesRouteImport
    }
    '/shared/projects/$sharedProjectId/': {
      id: '/shared/projects/$sharedProjectId/'
      path: '/shared/projects/$sharedProjectId'
      fullPath: '/shared/projects/$sharedProjectId'
      preLoaderRoute: typeof SharedProjectsSharedProjectIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/shared/projects/$sharedProjectId/claim/form': {
      id: '/shared/projects/$sharedProjectId/claim/form'
      path: '/shared/projects/$sharedProjectId/claim/form'
      fullPath: '/shared/projects/$sharedProjectId/claim/form'
      preLoaderRoute: typeof SharedProjectsSharedProjectIdClaimFormImport
      parentRoute: typeof rootRoute
    }
    '/shared/projects/$sharedProjectId/claim/': {
      id: '/shared/projects/$sharedProjectId/claim/'
      path: '/shared/projects/$sharedProjectId/claim'
      fullPath: '/shared/projects/$sharedProjectId/claim'
      preLoaderRoute: typeof SharedProjectsSharedProjectIdClaimIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppBillingRouteRoute: typeof AppBillingRouteRoute
  AppDashboardEmployeeRoute: typeof AppDashboardEmployeeRoute
  AppDashboardPmRoute: typeof AppDashboardPmRoute
  AppDashboardPortfolioRoute: typeof AppDashboardPortfolioRoute
  AppDashboardSamarbejdeRoute: typeof AppDashboardSamarbejdeRoute
  AppPartnersLinkRoute: typeof AppPartnersLinkRoute
  AppPlanningResourcesRoute: typeof AppPlanningResourcesRoute
  AppActivitiesIndexRoute: typeof AppActivitiesIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppPartnersIndexRoute: typeof AppPartnersIndexRoute
  AppPlanningIndexRoute: typeof AppPlanningIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppTimesheetIndexRoute: typeof AppTimesheetIndexRoute
  AppTimesheetsIndexRoute: typeof AppTimesheetsIndexRoute
  AppPartnerProjectsProjectIdIndexRoute: typeof AppPartnerProjectsProjectIdIndexRoute
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppReportsFeedbackIndexRoute: typeof AppReportsFeedbackIndexRoute
  AppReportsTrackersIndexRoute: typeof AppReportsTrackersIndexRoute
  AppResourcesResourceIdIndexRoute: typeof AppResourcesResourceIdIndexRoute
  AppTasksTaskIdIndexRoute: typeof AppTasksTaskIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBillingRouteRoute: AppBillingRouteRoute,
  AppDashboardEmployeeRoute: AppDashboardEmployeeRoute,
  AppDashboardPmRoute: AppDashboardPmRoute,
  AppDashboardPortfolioRoute: AppDashboardPortfolioRoute,
  AppDashboardSamarbejdeRoute: AppDashboardSamarbejdeRoute,
  AppPartnersLinkRoute: AppPartnersLinkRoute,
  AppPlanningResourcesRoute: AppPlanningResourcesRoute,
  AppActivitiesIndexRoute: AppActivitiesIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppPartnersIndexRoute: AppPartnersIndexRoute,
  AppPlanningIndexRoute: AppPlanningIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppTimesheetIndexRoute: AppTimesheetIndexRoute,
  AppTimesheetsIndexRoute: AppTimesheetsIndexRoute,
  AppPartnerProjectsProjectIdIndexRoute: AppPartnerProjectsProjectIdIndexRoute,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
  AppReportsFeedbackIndexRoute: AppReportsFeedbackIndexRoute,
  AppReportsTrackersIndexRoute: AppReportsTrackersIndexRoute,
  AppResourcesResourceIdIndexRoute: AppResourcesResourceIdIndexRoute,
  AppTasksTaskIdIndexRoute: AppTasksTaskIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface ExperiencesRouteRouteChildren {
  ExperiencesAcceptInvitationRoute: typeof ExperiencesAcceptInvitationRoute
  ExperiencesClaimPartnerRoute: typeof ExperiencesClaimPartnerRoute
  ExperiencesForgotPasswordRoute: typeof ExperiencesForgotPasswordRoute
  ExperiencesLoginRoute: typeof ExperiencesLoginRoute
  ExperiencesRegisterRoute: typeof ExperiencesRegisterRoute
  ExperiencesSignupRoute: typeof ExperiencesSignupRoute
  ExperiencesCreateNewCompanyStepIndexRoute: typeof ExperiencesCreateNewCompanyStepIndexRoute
}

const ExperiencesRouteRouteChildren: ExperiencesRouteRouteChildren = {
  ExperiencesAcceptInvitationRoute: ExperiencesAcceptInvitationRoute,
  ExperiencesClaimPartnerRoute: ExperiencesClaimPartnerRoute,
  ExperiencesForgotPasswordRoute: ExperiencesForgotPasswordRoute,
  ExperiencesLoginRoute: ExperiencesLoginRoute,
  ExperiencesRegisterRoute: ExperiencesRegisterRoute,
  ExperiencesSignupRoute: ExperiencesSignupRoute,
  ExperiencesCreateNewCompanyStepIndexRoute:
    ExperiencesCreateNewCompanyStepIndexRoute,
}

const ExperiencesRouteRouteWithChildren =
  ExperiencesRouteRoute._addFileChildren(ExperiencesRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/experiences': typeof ExperiencesRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/verify-account': typeof VerifyAccountRoute
  '/app/billing': typeof AppBillingRouteRoute
  '/experiences/accept-invitation': typeof ExperiencesAcceptInvitationRoute
  '/experiences/claim-partner': typeof ExperiencesClaimPartnerRoute
  '/experiences/forgot-password': typeof ExperiencesForgotPasswordRoute
  '/experiences/login': typeof ExperiencesLoginRoute
  '/experiences/register': typeof ExperiencesRegisterRoute
  '/experiences/signup': typeof ExperiencesSignupRoute
  '/admin/': typeof AdminIndexRoute
  '/app/dashboard/employee': typeof AppDashboardEmployeeRoute
  '/app/dashboard/pm': typeof AppDashboardPmRoute
  '/app/dashboard/portfolio': typeof AppDashboardPortfolioRoute
  '/app/dashboard/samarbejde': typeof AppDashboardSamarbejdeRoute
  '/app/partners/link': typeof AppPartnersLinkRoute
  '/app/planning/resources': typeof AppPlanningResourcesRoute
  '/print/plan-pdfs/$renderToken': typeof PrintPlanPdfsRenderTokenRoute
  '/app/activities': typeof AppActivitiesIndexRoute
  '/app/dashboard': typeof AppDashboardIndexRoute
  '/app/partners': typeof AppPartnersIndexRoute
  '/app/planning': typeof AppPlanningIndexRoute
  '/app/projects': typeof AppProjectsIndexRoute
  '/app/reports': typeof AppReportsIndexRoute
  '/app/resources': typeof AppResourcesIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/tasks': typeof AppTasksIndexRoute
  '/app/timesheet': typeof AppTimesheetIndexRoute
  '/app/timesheets': typeof AppTimesheetsIndexRoute
  '/feedback/$token': typeof FeedbackTokenIndexRoute
  '/app/partner-projects/$projectId': typeof AppPartnerProjectsProjectIdIndexRoute
  '/app/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/app/reports/feedback': typeof AppReportsFeedbackIndexRoute
  '/app/reports/trackers': typeof AppReportsTrackersIndexRoute
  '/app/resources/$resourceId': typeof AppResourcesResourceIdIndexRoute
  '/app/tasks/$taskId': typeof AppTasksTaskIdIndexRoute
  '/experiences/create-new-company/$step': typeof ExperiencesCreateNewCompanyStepIndexRoute
  '/shared/projects/$sharedProjectId': typeof SharedProjectsSharedProjectIdIndexRoute
  '/shared/projects/$sharedProjectId/claim/form': typeof SharedProjectsSharedProjectIdClaimFormRoute
  '/shared/projects/$sharedProjectId/claim': typeof SharedProjectsSharedProjectIdClaimIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/experiences': typeof ExperiencesRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/verify-account': typeof VerifyAccountRoute
  '/app/billing': typeof AppBillingRouteRoute
  '/experiences/accept-invitation': typeof ExperiencesAcceptInvitationRoute
  '/experiences/claim-partner': typeof ExperiencesClaimPartnerRoute
  '/experiences/forgot-password': typeof ExperiencesForgotPasswordRoute
  '/experiences/login': typeof ExperiencesLoginRoute
  '/experiences/register': typeof ExperiencesRegisterRoute
  '/experiences/signup': typeof ExperiencesSignupRoute
  '/admin': typeof AdminIndexRoute
  '/app/dashboard/employee': typeof AppDashboardEmployeeRoute
  '/app/dashboard/pm': typeof AppDashboardPmRoute
  '/app/dashboard/portfolio': typeof AppDashboardPortfolioRoute
  '/app/dashboard/samarbejde': typeof AppDashboardSamarbejdeRoute
  '/app/partners/link': typeof AppPartnersLinkRoute
  '/app/planning/resources': typeof AppPlanningResourcesRoute
  '/print/plan-pdfs/$renderToken': typeof PrintPlanPdfsRenderTokenRoute
  '/app/activities': typeof AppActivitiesIndexRoute
  '/app/dashboard': typeof AppDashboardIndexRoute
  '/app/partners': typeof AppPartnersIndexRoute
  '/app/planning': typeof AppPlanningIndexRoute
  '/app/projects': typeof AppProjectsIndexRoute
  '/app/reports': typeof AppReportsIndexRoute
  '/app/resources': typeof AppResourcesIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/tasks': typeof AppTasksIndexRoute
  '/app/timesheet': typeof AppTimesheetIndexRoute
  '/app/timesheets': typeof AppTimesheetsIndexRoute
  '/feedback/$token': typeof FeedbackTokenIndexRoute
  '/app/partner-projects/$projectId': typeof AppPartnerProjectsProjectIdIndexRoute
  '/app/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/app/reports/feedback': typeof AppReportsFeedbackIndexRoute
  '/app/reports/trackers': typeof AppReportsTrackersIndexRoute
  '/app/resources/$resourceId': typeof AppResourcesResourceIdIndexRoute
  '/app/tasks/$taskId': typeof AppTasksTaskIdIndexRoute
  '/experiences/create-new-company/$step': typeof ExperiencesCreateNewCompanyStepIndexRoute
  '/shared/projects/$sharedProjectId': typeof SharedProjectsSharedProjectIdIndexRoute
  '/shared/projects/$sharedProjectId/claim/form': typeof SharedProjectsSharedProjectIdClaimFormRoute
  '/shared/projects/$sharedProjectId/claim': typeof SharedProjectsSharedProjectIdClaimIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/experiences': typeof ExperiencesRouteRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/verify-account': typeof VerifyAccountRoute
  '/app/billing': typeof AppBillingRouteRoute
  '/experiences/accept-invitation': typeof ExperiencesAcceptInvitationRoute
  '/experiences/claim-partner': typeof ExperiencesClaimPartnerRoute
  '/experiences/forgot-password': typeof ExperiencesForgotPasswordRoute
  '/experiences/login': typeof ExperiencesLoginRoute
  '/experiences/register': typeof ExperiencesRegisterRoute
  '/experiences/signup': typeof ExperiencesSignupRoute
  '/admin/': typeof AdminIndexRoute
  '/app/dashboard/employee': typeof AppDashboardEmployeeRoute
  '/app/dashboard/pm': typeof AppDashboardPmRoute
  '/app/dashboard/portfolio': typeof AppDashboardPortfolioRoute
  '/app/dashboard/samarbejde': typeof AppDashboardSamarbejdeRoute
  '/app/partners/link': typeof AppPartnersLinkRoute
  '/app/planning/resources': typeof AppPlanningResourcesRoute
  '/print/plan-pdfs/$renderToken': typeof PrintPlanPdfsRenderTokenRoute
  '/app/activities/': typeof AppActivitiesIndexRoute
  '/app/dashboard/': typeof AppDashboardIndexRoute
  '/app/partners/': typeof AppPartnersIndexRoute
  '/app/planning/': typeof AppPlanningIndexRoute
  '/app/projects/': typeof AppProjectsIndexRoute
  '/app/reports/': typeof AppReportsIndexRoute
  '/app/resources/': typeof AppResourcesIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/tasks/': typeof AppTasksIndexRoute
  '/app/timesheet/': typeof AppTimesheetIndexRoute
  '/app/timesheets/': typeof AppTimesheetsIndexRoute
  '/feedback/$token/': typeof FeedbackTokenIndexRoute
  '/app/partner-projects/$projectId/': typeof AppPartnerProjectsProjectIdIndexRoute
  '/app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/app/reports/feedback/': typeof AppReportsFeedbackIndexRoute
  '/app/reports/trackers/': typeof AppReportsTrackersIndexRoute
  '/app/resources/$resourceId/': typeof AppResourcesResourceIdIndexRoute
  '/app/tasks/$taskId/': typeof AppTasksTaskIdIndexRoute
  '/experiences/create-new-company/$step/': typeof ExperiencesCreateNewCompanyStepIndexRoute
  '/shared/projects/$sharedProjectId/': typeof SharedProjectsSharedProjectIdIndexRoute
  '/shared/projects/$sharedProjectId/claim/form': typeof SharedProjectsSharedProjectIdClaimFormRoute
  '/shared/projects/$sharedProjectId/claim/': typeof SharedProjectsSharedProjectIdClaimIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/experiences'
    | '/reset-password'
    | '/verify-account'
    | '/app/billing'
    | '/experiences/accept-invitation'
    | '/experiences/claim-partner'
    | '/experiences/forgot-password'
    | '/experiences/login'
    | '/experiences/register'
    | '/experiences/signup'
    | '/admin/'
    | '/app/dashboard/employee'
    | '/app/dashboard/pm'
    | '/app/dashboard/portfolio'
    | '/app/dashboard/samarbejde'
    | '/app/partners/link'
    | '/app/planning/resources'
    | '/print/plan-pdfs/$renderToken'
    | '/app/activities'
    | '/app/dashboard'
    | '/app/partners'
    | '/app/planning'
    | '/app/projects'
    | '/app/reports'
    | '/app/resources'
    | '/app/settings'
    | '/app/tasks'
    | '/app/timesheet'
    | '/app/timesheets'
    | '/feedback/$token'
    | '/app/partner-projects/$projectId'
    | '/app/projects/$projectId'
    | '/app/reports/feedback'
    | '/app/reports/trackers'
    | '/app/resources/$resourceId'
    | '/app/tasks/$taskId'
    | '/experiences/create-new-company/$step'
    | '/shared/projects/$sharedProjectId'
    | '/shared/projects/$sharedProjectId/claim/form'
    | '/shared/projects/$sharedProjectId/claim'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/experiences'
    | '/reset-password'
    | '/verify-account'
    | '/app/billing'
    | '/experiences/accept-invitation'
    | '/experiences/claim-partner'
    | '/experiences/forgot-password'
    | '/experiences/login'
    | '/experiences/register'
    | '/experiences/signup'
    | '/admin'
    | '/app/dashboard/employee'
    | '/app/dashboard/pm'
    | '/app/dashboard/portfolio'
    | '/app/dashboard/samarbejde'
    | '/app/partners/link'
    | '/app/planning/resources'
    | '/print/plan-pdfs/$renderToken'
    | '/app/activities'
    | '/app/dashboard'
    | '/app/partners'
    | '/app/planning'
    | '/app/projects'
    | '/app/reports'
    | '/app/resources'
    | '/app/settings'
    | '/app/tasks'
    | '/app/timesheet'
    | '/app/timesheets'
    | '/feedback/$token'
    | '/app/partner-projects/$projectId'
    | '/app/projects/$projectId'
    | '/app/reports/feedback'
    | '/app/reports/trackers'
    | '/app/resources/$resourceId'
    | '/app/tasks/$taskId'
    | '/experiences/create-new-company/$step'
    | '/shared/projects/$sharedProjectId'
    | '/shared/projects/$sharedProjectId/claim/form'
    | '/shared/projects/$sharedProjectId/claim'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/experiences'
    | '/reset-password'
    | '/verify-account'
    | '/app/billing'
    | '/experiences/accept-invitation'
    | '/experiences/claim-partner'
    | '/experiences/forgot-password'
    | '/experiences/login'
    | '/experiences/register'
    | '/experiences/signup'
    | '/admin/'
    | '/app/dashboard/employee'
    | '/app/dashboard/pm'
    | '/app/dashboard/portfolio'
    | '/app/dashboard/samarbejde'
    | '/app/partners/link'
    | '/app/planning/resources'
    | '/print/plan-pdfs/$renderToken'
    | '/app/activities/'
    | '/app/dashboard/'
    | '/app/partners/'
    | '/app/planning/'
    | '/app/projects/'
    | '/app/reports/'
    | '/app/resources/'
    | '/app/settings/'
    | '/app/tasks/'
    | '/app/timesheet/'
    | '/app/timesheets/'
    | '/feedback/$token/'
    | '/app/partner-projects/$projectId/'
    | '/app/projects/$projectId/'
    | '/app/reports/feedback/'
    | '/app/reports/trackers/'
    | '/app/resources/$resourceId/'
    | '/app/tasks/$taskId/'
    | '/experiences/create-new-company/$step/'
    | '/shared/projects/$sharedProjectId/'
    | '/shared/projects/$sharedProjectId/claim/form'
    | '/shared/projects/$sharedProjectId/claim/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  ExperiencesRouteRoute: typeof ExperiencesRouteRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyAccountRoute: typeof VerifyAccountRoute
  PrintPlanPdfsRenderTokenRoute: typeof PrintPlanPdfsRenderTokenRoute
  FeedbackTokenIndexRoute: typeof FeedbackTokenIndexRoute
  SharedProjectsSharedProjectIdIndexRoute: typeof SharedProjectsSharedProjectIdIndexRoute
  SharedProjectsSharedProjectIdClaimFormRoute: typeof SharedProjectsSharedProjectIdClaimFormRoute
  SharedProjectsSharedProjectIdClaimIndexRoute: typeof SharedProjectsSharedProjectIdClaimIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  ExperiencesRouteRoute: ExperiencesRouteRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyAccountRoute: VerifyAccountRoute,
  PrintPlanPdfsRenderTokenRoute: PrintPlanPdfsRenderTokenRoute,
  FeedbackTokenIndexRoute: FeedbackTokenIndexRoute,
  SharedProjectsSharedProjectIdIndexRoute:
    SharedProjectsSharedProjectIdIndexRoute,
  SharedProjectsSharedProjectIdClaimFormRoute:
    SharedProjectsSharedProjectIdClaimFormRoute,
  SharedProjectsSharedProjectIdClaimIndexRoute:
    SharedProjectsSharedProjectIdClaimIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin",
        "/app",
        "/experiences",
        "/reset-password",
        "/verify-account",
        "/print/plan-pdfs/$renderToken",
        "/feedback/$token/",
        "/shared/projects/$sharedProjectId/",
        "/shared/projects/$sharedProjectId/claim/form",
        "/shared/projects/$sharedProjectId/claim/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin": {
      "filePath": "admin/route.tsx",
      "children": [
        "/admin/"
      ]
    },
    "/app": {
      "filePath": "app/route.tsx",
      "children": [
        "/app/billing",
        "/app/dashboard/employee",
        "/app/dashboard/pm",
        "/app/dashboard/portfolio",
        "/app/dashboard/samarbejde",
        "/app/partners/link",
        "/app/planning/resources",
        "/app/activities/",
        "/app/dashboard/",
        "/app/partners/",
        "/app/planning/",
        "/app/projects/",
        "/app/reports/",
        "/app/resources/",
        "/app/settings/",
        "/app/tasks/",
        "/app/timesheet/",
        "/app/timesheets/",
        "/app/partner-projects/$projectId/",
        "/app/projects/$projectId/",
        "/app/reports/feedback/",
        "/app/reports/trackers/",
        "/app/resources/$resourceId/",
        "/app/tasks/$taskId/"
      ]
    },
    "/experiences": {
      "filePath": "experiences/route.tsx",
      "children": [
        "/experiences/accept-invitation",
        "/experiences/claim-partner",
        "/experiences/forgot-password",
        "/experiences/login",
        "/experiences/register",
        "/experiences/signup",
        "/experiences/create-new-company/$step/"
      ]
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/verify-account": {
      "filePath": "verify-account.tsx"
    },
    "/app/billing": {
      "filePath": "app/billing/route.tsx",
      "parent": "/app"
    },
    "/experiences/accept-invitation": {
      "filePath": "experiences/accept-invitation.tsx",
      "parent": "/experiences"
    },
    "/experiences/claim-partner": {
      "filePath": "experiences/claim-partner.tsx",
      "parent": "/experiences"
    },
    "/experiences/forgot-password": {
      "filePath": "experiences/forgot-password.tsx",
      "parent": "/experiences"
    },
    "/experiences/login": {
      "filePath": "experiences/login.tsx",
      "parent": "/experiences"
    },
    "/experiences/register": {
      "filePath": "experiences/register.tsx",
      "parent": "/experiences"
    },
    "/experiences/signup": {
      "filePath": "experiences/signup.tsx",
      "parent": "/experiences"
    },
    "/admin/": {
      "filePath": "admin/index.tsx",
      "parent": "/admin"
    },
    "/app/dashboard/employee": {
      "filePath": "app/dashboard/employee.tsx",
      "parent": "/app"
    },
    "/app/dashboard/pm": {
      "filePath": "app/dashboard/pm.tsx",
      "parent": "/app"
    },
    "/app/dashboard/portfolio": {
      "filePath": "app/dashboard/portfolio.tsx",
      "parent": "/app"
    },
    "/app/dashboard/samarbejde": {
      "filePath": "app/dashboard/samarbejde.tsx",
      "parent": "/app"
    },
    "/app/partners/link": {
      "filePath": "app/partners/link.tsx",
      "parent": "/app"
    },
    "/app/planning/resources": {
      "filePath": "app/planning/resources.tsx",
      "parent": "/app"
    },
    "/print/plan-pdfs/$renderToken": {
      "filePath": "print/plan-pdfs/$renderToken.tsx"
    },
    "/app/activities/": {
      "filePath": "app/activities/index.tsx",
      "parent": "/app"
    },
    "/app/dashboard/": {
      "filePath": "app/dashboard/index.tsx",
      "parent": "/app"
    },
    "/app/partners/": {
      "filePath": "app/partners/index.tsx",
      "parent": "/app"
    },
    "/app/planning/": {
      "filePath": "app/planning/index.tsx",
      "parent": "/app"
    },
    "/app/projects/": {
      "filePath": "app/projects/index.tsx",
      "parent": "/app"
    },
    "/app/reports/": {
      "filePath": "app/reports/index.tsx",
      "parent": "/app"
    },
    "/app/resources/": {
      "filePath": "app/resources/index.tsx",
      "parent": "/app"
    },
    "/app/settings/": {
      "filePath": "app/settings/index.tsx",
      "parent": "/app"
    },
    "/app/tasks/": {
      "filePath": "app/tasks/index.tsx",
      "parent": "/app"
    },
    "/app/timesheet/": {
      "filePath": "app/timesheet/index.tsx",
      "parent": "/app"
    },
    "/app/timesheets/": {
      "filePath": "app/timesheets/index.tsx",
      "parent": "/app"
    },
    "/feedback/$token/": {
      "filePath": "feedback/$token/index.tsx"
    },
    "/app/partner-projects/$projectId/": {
      "filePath": "app/partner-projects/$projectId/index.tsx",
      "parent": "/app"
    },
    "/app/projects/$projectId/": {
      "filePath": "app/projects/$projectId/index.tsx",
      "parent": "/app"
    },
    "/app/reports/feedback/": {
      "filePath": "app/reports/feedback/index.tsx",
      "parent": "/app"
    },
    "/app/reports/trackers/": {
      "filePath": "app/reports/trackers/index.tsx",
      "parent": "/app"
    },
    "/app/resources/$resourceId/": {
      "filePath": "app/resources/$resourceId/index.tsx",
      "parent": "/app"
    },
    "/app/tasks/$taskId/": {
      "filePath": "app/tasks/$taskId/index.tsx",
      "parent": "/app"
    },
    "/experiences/create-new-company/$step/": {
      "filePath": "experiences/create-new-company/$step/index.tsx",
      "parent": "/experiences"
    },
    "/shared/projects/$sharedProjectId/": {
      "filePath": "shared/projects/$sharedProjectId/index.tsx"
    },
    "/shared/projects/$sharedProjectId/claim/form": {
      "filePath": "shared/projects/$sharedProjectId/claim/form.tsx"
    },
    "/shared/projects/$sharedProjectId/claim/": {
      "filePath": "shared/projects/$sharedProjectId/claim/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
